import { ItemId } from "../../../model/datasource";
import { ContentItem } from "../../../model/datasource/item";
import { AnswerType } from "../../../lib/userdata";
import { MathJaxObject } from "mathjax-full/js/components/startup";
import { DisplayItemFrontend } from "./displayitem";

export class FlashcardFrontend<I extends ItemId> extends DisplayItemFrontend<I> {
	displayItemContent(content: ContentItem<I>, bindTarget: EventTarget): void {
		const card = document.querySelector('.item .flashcard');

		const name = card.querySelector('.name');
		const front = card.querySelector('.question');
		const back = card.querySelector('.answer');
		const style = card.querySelector('style');
		name.innerHTML = content.name + '.';
		front.innerHTML = content.flashcard.question;
		back.innerHTML = content.flashcard.answer;
		style.innerText = content.flashcard.style;

		card.classList.remove('d-none');
		card.classList.add('invisible');
	}

	displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: AnswerType | undefined): void {
		throw new Error("Method not implemented.");
	}

	displayItemReview(content: ContentItem<I>, answer: AnswerType | undefined): void {
		throw new Error("Method not implemented.");
	}

	displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void {
		const card = document.querySelector('.item .flashcard');
		mathjax.typesetPromise().then(() => {
			card.classList.remove('invisible');
		});
	}

	displayItemAlerts(content: ContentItem<I>): void {
		// Do nothing.
		return;
	}
}